import { isAndroid, isIOS, isIPad, isIPod, isLinux, isMobile, isOSX, isWindows, osVersion } from '../utils';
import { OsVersion } from './models';

export class OS {

    static get linux(): boolean {
        return isLinux() && !isAndroid();
    }

    static get android(): boolean {
        return isAndroid();
    }

    static get iOS(): boolean {
        return isIOS();
    }

    static get mobile(): boolean {
        return isMobile();
    }

    static get mac(): boolean {
        return isOSX();
    }

    static get iPad(): boolean {
        return isIPad();
    }

    static get iPhone(): boolean {
        return isIPod();
    }

    static get windows(): boolean {
        return isWindows();
    }

    static get version(): OsVersion {
        return osVersion(this, navigator.userAgent);
    }
}
